import { initPlasmicLoader } from "@plasmicapp/loader-react";
export const PLASMIC = initPlasmicLoader({
  projects: [
    {
      id: "fAUGSepiVXBsEXwhq6NtKN",  // ID of a project you are using
      token: "Y48b9pLYDToNtqwY5ytNokY10DYRPZmxQPAYnCS924Sr0xPYbX78AwrupU8yYuYeurfo1Yenp5MtikTYVloQ"  // API token for that project
    }
  ],
  // Fetches the latest revisions, whether or not they were unpublished!
  // Disable for production to ensure you render only published changes.
  preview: true,
})